import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandStorePackageOfferConfig = (brandId, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/store-package-offer/' +
      storeId,
    headers: getHeaders(),
  });
};

export const addStoreBrandPackageOfferConfig = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/store-package-offer',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

